module.exports = __webpack_public_path__ + "img/lite-dark.b3849d43.svg";